import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import defaultImage from "../../assets/img/profiles/icons8-test-account-90.png";

import {
  logo,
  logosmall,
  headericon01,
  headericon05,
  avatar02,
  avatar11,
  avatar17,
  avatar13,
  headericon04,
  avatar01,
  lr,
  bl,
  cn,
  favicon,
} from "../imagepath";
import "./header.css";
import { userInformation } from "../HttpRequest/userdetails";
import UserProfile from "../commen/userinteface";
import {
  getUserDocuments,
  postDocuments,
  uploadUserProfile,
} from "../HttpRequest/uploadDocuments";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { WarningAlert } from "../pages/Base UI Elements/SweetAlert";

const Header = ({ profileUrl }) => {
  const [dashboarddata, setdashboarddata] = useState({
    profileData: UserProfile(),
  });

  const handlesidebar = () => {
    document.body.classList.toggle("mini-sidebar");
  };

  const handlesidebarmobilemenu = () => {
    document.body.classList.toggle("slide-nav");
  };
  const [profileImageUrl, setProfileImageUrl] = useState(defaultImage);

  const history = useHistory();

  const logOutMethod = () => {
    sessionStorage.clear();
    localStorage.clear();
    history.push("/");
  };

  useEffect(() => {
    const userId = sessionStorage.getItem("id") || localStorage.getItem("id");

    const handleClick = () => {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        }
      }
    };

    const fetchData = async () => {
      try {
        const response = await userInformation(userId);
        console.log("response", response.data);

        if (response.data.profilePic) {
          await downloadProfile(response.data.id, response.data.profilePic);
        }
        setdashboarddata({
          profileData: response.data,
        });
      } catch (error) {
        console.error("Error fetching profile data:", error);
      }
    };

    fetchData();

    const maximizeBtn = document.querySelector(".win-maximize");
    maximizeBtn.addEventListener("click", handleClick);

    return () => {
      maximizeBtn.removeEventListener("click", handleClick);
    };
  }, []);

  const downloadProfile = async (userId, key) => {
    console.log("image download method url-->", userId, key);
    const headers = new Headers({ "Content-Type": "application/octet-stream" });
    const options = { headers, responseType: "blob" };
    try {
      const response = await getUserDocuments(userId, key, options);
      console.log("Response from getUserDocuments:", response);
      if (response && response.headers && response.data) {
        const contentType = response.headers["content-type"];
        const blob = new Blob([response.data], { type: contentType });
        if (blob instanceof Blob) {
          setProfileImageUrl(URL.createObjectURL(blob));
          // profileUrl(URL.createObjectURL(blob));
          return URL.createObjectURL(blob);
        } else {
          console.error("Invalid blob data received:", blob);
        }
      } else {
        console.error("Invalid response from getUserDocuments:", response);
        return null;
      }
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  };

  const handleUpload = async (event, type) => {
    let userId = sessionStorage.getItem("id") || localStorage.getItem("id");
    try {
      console.log("event profile-->", event.target.files[0]);
      const fileInput = event.target;
      const file = fileInput.files[0];
      // const MAX_FILE_SIZE_MB = 5;
      // const fileSizeInMB = file.size / (1024 * 1024);
      //&&fileSizeInMB > MAX_FILE_SIZE_MB
      if (file && file.type.includes("image")) {
        setProfileImageUrl(URL.createObjectURL(file));
        const response = await uploadUserProfile(
          userId,
          type,
          file
        );
        if (response?.data?.s3Key) {
          downloadProfile(userId, response.data.s3Key);
        }
        console.log("Image file selected:", file);
        return response;
      } else {
        WarningAlert("Invalid file type. Please select an image file.", null);
        console.error("Invalid file type. Please select an image file.");
      }
      console.log("Document upload successful:", response);
    } catch (error) {
      console.error("Error uploading document:", error);
      setUploadSuccess(false);
      setError("Error uploading file. Please try again.");
    }
  };

  return (
    <>
      {/* Header */}
      <div className="header">
        {/* Logo */}
        <div className="header-left">
          <Link to="/admindashboard" className="logo">
            <img src={favicon} alt="EdOps OS" className="logofor" />
          </Link>
          <Link to="/admindashboard" className="logo logo-small">
            <img src={favicon} alt="EdOps OS" width={30} height={30} />
          </Link>
        </div>
        {/* /Logo */}
        <div className="menu-toggle">
          <Link to="#" id="toggle_btn" onClick={handlesidebar}>
            <i className="fas fa-bars" />
          </Link>
        </div>
        {/* Search Bar */}
        <div className="top-nav-search" style={{ display: "none" }}>
          <form>
            <input
              type="text"
              className="form-control"
              placeholder="Search here"
            />
            <button className="btn" type="submit">
              <i className="fas fa-search" />
            </button>
          </form>
        </div>
        {/* /Search Bar */}
        {/* Mobile Menu Toggle */}
        <Link
          to="#"
          className="mobile_btn"
          id="mobile_btn"
          onClick={() => handlesidebarmobilemenu()}
        >
          <i className="fas fa-bars" />
        </Link>
        {/* /Mobile Menu Toggle */}
        {/* Header Right Menu */}
        <ul className="nav user-menu">
          <li
            className="nav-item dropdown language-drop me-2"
            style={{ display: "none" }}
          >
            <Link
              to="#"
              className="dropdown-toggle nav-link header-nav-list"
              data-bs-toggle="dropdown"
            >
              <img src={headericon01} alt="" />
            </Link>
            {/* <div className="dropdown-menu">
              <Link to="#" className="dropdown-item">
                <img src={lr} alt="" height={16} />
                <span className="flagg">English</span>
              </Link>
              <Link to="#" className="dropdown-item">
                <img src={bl} alt="" height={16} />
                <span className="flagg">Francais</span>
              </Link>
              <Link to="#" className="dropdown-item">
                <img src={cn} alt="" height={16} />
                <span className="flagg">Turkce</span>
              </Link>
            </div> */}
          </li>
          {/* Notifications */}
          <li className="nav-item dropdown noti-dropdown me-2">
            <Link
              to="#"
              className="dropdown-toggle nav-link header-nav-list"
              data-bs-toggle="dropdown"
            >
              <img src={headericon05} alt="" />
            </Link>
            <div className="dropdown-menu notifications">
              <div className="topnav-dropdown-header">
                <span className="notification-title">Notifications</span>
                <Link to="#" className="clear-noti">
                  Clear All
                </Link>
              </div>
              <div className="noti-content">
                <ul className="notification-list">
                  <li className="notification-message">
                    <Link to="#">
                      <div className="media d-flex">
                        <span className="avatar avatar-sm flex-shrink-0">
                          <img
                            className="avatar-img rounded-circle"
                            alt="User Image"
                            src={avatar02}
                          />
                        </span>
                        <div className="media-body flex-grow-1">
                          <p className="noti-details">
                            <span className="noti-title">Carlson Tech</span> has
                            approved{" "}
                            <span className="noti-title">your estimate</span>
                          </p>
                          <p className="noti-time">
                            <span className="notification-time">
                              4 mins ago
                            </span>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li className="notification-message">
                    <Link to="#">
                      <div className="media d-flex">
                        <span className="avatar avatar-sm flex-shrink-0">
                          <img
                            className="avatar-img rounded-circle"
                            alt="User Image"
                            src={avatar11}
                          />
                        </span>
                        <div className="media-body flex-grow-1">
                          <p className="noti-details">
                            <span className="noti-title">
                              International Software Inc
                            </span>{" "}
                            has sent you a invoice in the amount of{" "}
                            <span className="noti-title">$218</span>
                          </p>
                          <p className="noti-time">
                            <span className="notification-time">
                              6 mins ago
                            </span>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li className="notification-message">
                    <Link to="#">
                      <div className="media d-flex">
                        <span className="avatar avatar-sm flex-shrink-0">
                          <img
                            className="avatar-img rounded-circle"
                            alt="User Image"
                            src={avatar17}
                          />
                        </span>
                        <div className="media-body flex-grow-1">
                          <p className="noti-details">
                            <span className="noti-title">John Hendry</span> sent
                            a cancellation request{" "}
                            <span className="noti-title">Apple iPhone XR</span>
                          </p>
                          <p className="noti-time">
                            <span className="notification-time">
                              8 mins ago
                            </span>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li className="notification-message">
                    <Link to="#">
                      <div className="media d-flex">
                        <span className="avatar avatar-sm flex-shrink-0">
                          <img
                            className="avatar-img rounded-circle"
                            alt="User Image"
                            src={avatar13}
                          />
                        </span>
                        <div className="media-body flex-grow-1">
                          <p className="noti-details">
                            <span className="noti-title">
                              Mercury Software Inc
                            </span>{" "}
                            added a new product{" "}
                            <span className="noti-title">
                              Apple MacBook Pro
                            </span>
                          </p>
                          <p className="noti-time">
                            <span className="notification-time">
                              12 mins ago
                            </span>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="topnav-dropdown-footer">
                <Link to="#">View all Notifications</Link>
              </div>
            </div>
          </li>
          {/* /Notifications */}
          {/* <li className="nav-item zoom-screen me-2">
                                <Link to="#" className="nav-link header-nav-list">
                                    <img src={headericon04} alt="" />
                                </Link>
                            </li> */}
          <li className="nav-item has-arrow dropdown-heads me-2">
            <Link to="#" className="win-maximize maximize-icon header-nav-list">
              <img src={headericon04} alt="" />
            </Link>
          </li>
          {/* User Menu */}
          <li className="nav-item dropdown has-arrow new-user-menus d-flex align-items-center">
            <Link
              to="#"
              className="dropdown-toggle nav-link d-flex align-items-center gap-2 px-2 py-1"
              data-bs-toggle="dropdown"
              style={{ textDecoration: "none" }}
            >
              <span className="user-img position-relative d-inline-flex align-items-center">
                <img
                  className="rounded-circle"
                  id="imageElement"
                  src={profileImageUrl || defaultImage}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = defaultImage;
                  }}
                  width={34}
                  height={34}
                  alt="profile"
                  style={{ border: "2px solid #D4AF37", objectFit: "cover" }}
                />
              </span>
              <div className="user-text text-wrap text-capitalize">
                <h6 className="mb-0 text-white font-weight-bold" style={{ fontSize: "14px" }}>
                  {dashboarddata.profileData === null ||
                  dashboarddata.profileData === undefined
                    ? "User"
                    : dashboarddata.profileData.firstName}
                </h6>
              </div>
            </Link>

            <input
              type="file"
              id="fileInputProfile"
              accept="image/png, image/gif, image/jpeg"
              style={{ display: "none" }}
              onChange={(event) => handleUpload(event, "profilePic")}
            />

            {(() => {
              const storedRole = (
                sessionStorage.getItem("userRole") ||
                localStorage.getItem("userRole") ||
                dashboarddata.profileData?.role ||
                "student"
              ).toLowerCase();

              const getRoleLabel = (r) => {
                if (r.includes("assistant")) return "Assistant ID:";
                if (r.includes("counsellor")) return "Counsellor ID:";
                if (r.includes("loan")) return "Officer ID:";
                if (r.includes("admin")) return "Staff ID:";
                return "StudentID:";
              };

              const formatRoleTitle = (r) => {
                if (r.includes("assistant")) return "Application Assistant";
                if (r.includes("counsellor")) return "Counsellor";
                if (r.includes("loan")) return "Loan Officer";
                if (r.includes("super-admin") || r.includes("super_admin")) return "Super Admin";
                if (r.includes("admin")) return "Administrator";
                return "Student";
              };

              const currentId =
                dashboarddata.profileData != null && dashboarddata.profileData.id
                  ? dashboarddata.profileData.id
                  : sessionStorage.getItem("id") || "10251";

              const fullName =
                dashboarddata.profileData?.firstName
                  ? `${dashboarddata.profileData.firstName} ${dashboarddata.profileData.lastName || ""}`.trim()
                  : "User Profile";

              return (
                <div
                  className="dropdown-menu dropdown-menu-end shadow-lg"
                  style={{
                    background: "#141824",
                    border: "1px solid rgba(212, 175, 55, 0.28)",
                    borderRadius: "12px",
                    minWidth: "240px",
                    zIndex: 1065,
                    overflow: "hidden",
                    padding: 0,
                  }}
                >
                  {/* User Profile Header */}
                  <div
                    className="p-3"
                    style={{
                      background: "linear-gradient(135deg, rgba(212, 175, 55, 0.12) 0%, rgba(20, 24, 36, 0.95) 100%)",
                      borderBottom: "1px solid rgba(212, 175, 55, 0.18)",
                    }}
                  >
                    <div className="d-flex align-items-center gap-2 mb-2">
                      <img
                        className="rounded-circle flex-shrink-0"
                        src={profileImageUrl || defaultImage}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = defaultImage;
                        }}
                        width={36}
                        height={36}
                        alt="avatar"
                        style={{ border: "2px solid #D4AF37", objectFit: "cover" }}
                      />
                      <div style={{ minWidth: 0 }}>
                        <h6 className="text-white font-weight-bold mb-0 text-truncate" style={{ fontSize: "14px" }}>
                          {fullName}
                        </h6>
                        <div className="text-muted" style={{ fontSize: "11px" }}>
                          {getRoleLabel(storedRole)}{" "}
                          <span className="text-warning font-weight-bold">
                            {currentId}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="d-flex align-items-center justify-content-between pt-1">
                      <span
                        style={{
                          fontSize: "10px",
                          fontWeight: 700,
                          letterSpacing: "0.5px",
                          textTransform: "uppercase",
                          padding: "2px 8px",
                          borderRadius: "4px",
                          background: "rgba(212, 175, 55, 0.2)",
                          color: "#FFE082",
                          border: "1px solid rgba(212, 175, 55, 0.35)",
                        }}
                      >
                        {formatRoleTitle(storedRole)}
                      </span>
                      <span className="text-success small d-flex align-items-center gap-1" style={{ fontSize: "11px" }}>
                        <span style={{ width: "6px", height: "6px", borderRadius: "50%", background: "#28a745", display: "inline-block" }}></span> Online
                      </span>
                    </div>
                  </div>

                  {/* Navigation Links */}
                  <div className="py-1">
                    <Link
                      className="dropdown-item d-flex align-items-center py-2 px-3 text-light"
                      to="/profile"
                      style={{ borderTop: "none" }}
                    >
                      <i className="fas fa-user-circle me-3 text-warning" style={{ width: "18px", textAlign: "center", fontSize: "15px" }}></i>
                      <span>My Profile</span>
                    </Link>

                    {(storedRole === "user" || storedRole === "student") && (
                      <Link
                        className="dropdown-item d-flex align-items-center py-2 px-3 text-light"
                        to="/bookdeal"
                        style={{ borderTop: "none" }}
                      >
                        <i className="fas fa-tags me-3 text-warning" style={{ width: "18px", textAlign: "center", fontSize: "15px" }}></i>
                        <span>My Deals</span>
                      </Link>
                    )}

                    <div style={{ height: "1px", background: "rgba(255, 255, 255, 0.08)", margin: "4px 0" }}></div>

                    <Link
                      className="dropdown-item d-flex align-items-center py-2 px-3 text-danger"
                      to="/"
                      onClick={logOutMethod}
                      style={{ borderTop: "none" }}
                    >
                      <i className="fas fa-sign-out-alt me-3" style={{ width: "18px", textAlign: "center", fontSize: "15px" }}></i>
                      <span>Logout</span>
                    </Link>
                  </div>
                </div>
              );
            })()}
          </li>
          {/* /User Menu */}
        </ul>
        {/* /Header Right Menu */}
      </div>
      {/* /Header */}
    </>
  );
};

export default Header;
